<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-6 col-7">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" [routerLink]="['/']">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)" > My Organization </a>
              </li>

            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>
<div class=" container-fluid mt--6">
  <form [formGroup]="organizationForm" (ngSubmit)="onSubmit()">
    <div class=" row">
      <div class=" col-lg">
        <div class=" card-wrapper">
          <div formGroupName="organizeInfo">
            <div class="card" >
              <div class="card-header">
                <div class="row">
                  <div class="col-md-9 col-lg-9 col-sm-12">
                    <h3 class=" mb-0">Organization Information</h3>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Legal Name
                        </label>
                        <div class="col-md-9">
                          <input type="text"
                                 class="form-control"
                                 formControlName="name" >
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Street Name
                        </label>
                        <div class="col-md-9">
                          <input type="text"
                                 class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressStreet')?.invalid
                               && organizationForm.get('organizeInfo.addressStreet')?.touched }"
                                 id="streetNameInput"
                                 formControlName="addressStreet"
                                 [maxlength]="accountTextLimits.addressStreet">
                          <div  class="invalid-feedback" >
                            <div *ngIf="organizationForm.get('organizeInfo.addressStreet')?.hasError('required')">
                              Street Name is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressStreet')?.hasError('maxlength')">
                              Street Name cannot exceed {{ accountTextLimits.addressStreet }} characters.
                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          City
                        </label>
                        <div class="col-md-9">
                          <input type="text" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressCity')?.invalid
                               && organizationForm.get('organizeInfo.addressCity')?.touched }"
                                 id="cityInput" formControlName="addressCity"
                                 [maxlength]="accountTextLimits.addressCity">
                          <div  class="invalid-feedback" >
                            <div *ngIf="organizationForm.get('organizeInfo.addressCity')?.hasError('required')">
                              City is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressCity')?.hasError('maxlength')">
                              City cannot exceed {{ accountTextLimits.addressCity }} characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Postal Code
                        </label>
                        <div class="col-md-9">
                          <input type="text" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressPostal')?.invalid
                               && organizationForm.get('organizeInfo.addressPostal')?.touched }"
                                 id="PostalCodeInput" formControlName="addressPostal"
                                 [maxlength]="accountTextLimits.addressPostal">
                          <div  class="invalid-feedback" >
                            <div *ngIf="organizationForm.get('organizeInfo.addressPostal')?.hasError('required')">
                              Postal Code is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.addressPostal')?.hasError('maxlength')">
                              Postal Code cannot exceed {{ accountTextLimits.addressPostal }} characters.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Country
                        </label>
                        <div class="col-md-9">
                          <select class="form-control"
                                  [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.addressCountry')?.invalid
                               && organizationForm.get('organizeInfo.addressCountry')?.touched }"
                                  name="caddressCountry" id="caddressCountryDdl" formControlName="addressCountry">
                            <option *ngFor="let value of counties" [value]="value.id">{{value.name}}</option>

                          </select>
                          <div  class="invalid-feedback" >
                            Country is required.
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Email
                        </label>
                        <div class="col-md-9">
                          <input type="text" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.email')?.invalid
                               && organizationForm.get('organizeInfo.email')?.touched }"
                                 id="emailInput" formControlName="email">
                          <div  class="invalid-feedback" >
                            Email is required.
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Approximate Annual Budget
                        </label>
                        <div class="col-md-3">
                          <input type="number" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.annualBudget')?.invalid
                               && organizationForm.get('organizeInfo.annualBudget')?.touched }"
                                 id="aabInput" placeholder="0" formControlName="annualBudget"
                                 min="0" step="1" [max]="accountLimits.annualBudget.max"
                                 (keypress)="$event.charCode >= 48 && $event.charCode <= 57">
                          <div class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('required')">
                              Approximate Annual Budget is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('wholeNumber')">
                              Approximate Annual Budget must be a whole number (no decimals).
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('min')">
                              Approximate Annual Budget cannot be negative.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.annualBudget')?.hasError('max')">
                              Approximate Annual Budget cannot exceed {{ accountLimits.annualBudget.max | number }}.
                            </div>
                          </div>
                        </div>
                        <label class="col-md-2 col-form-label form-control-label">
                          Currency
                        </label>
                        <div class="col-md-4">
                          <select [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.currencyId')?.invalid
                               && organizationForm.get('organizeInfo.currencyId')?.touched }"
                                  class="form-control"
                                  formControlName="currencyId" id="currencyDdl" name="cars">
                            <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                          </select>
                          <div
                            *ngIf="organizationForm.get('organizeInfo.currencyId')?.invalid     && organizationForm.get('organizeInfo.currencyId')?.touched"
                            class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('required')">
                              Currency is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('maxlength')">
                              Currency cannot
                              exceed {{ organizationForm.get('organizeInfo.currencyId')?.errors?.['maxlength'].requiredLength }}
                              characters.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.currencyId')?.hasError('pattern')">
                              Currency must use Latin characters only.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Website
                        </label>
                        <div class="col-md-9">
                          <input type="text"
                                 class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.webSiteUrl')?.invalid
                               && organizationForm.get('organizeInfo.webSiteUrl')?.touched }"
                                 id="websiteInput" formControlName="webSiteUrl"
                                 [maxlength]="accountTextLimits.webSiteUrl">
                          <div  class="invalid-feedback" >
                            <div *ngIf="organizationForm.get('organizeInfo.webSiteUrl')?.hasError('required')">
                              Website is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.webSiteUrl')?.hasError('maxlength')">
                              Website cannot exceed {{ accountTextLimits.webSiteUrl }} characters.
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Number of Staff
                        </label>
                        <div class="col-md-9">
                          <input type="number" step="1" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.numberOfEmployees')?.invalid
                               && organizationForm.get('organizeInfo.numberOfEmployees')?.touched }"
                                 id="numberOfStaffInput" formControlName="numberOfEmployees"
                                 [min]="accountLimits.numberOfEmployees.min" [max]="accountLimits.numberOfEmployees.max">
                          <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.invalid && organizationForm.get('organizeInfo.numberOfEmployees')?.touched" class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('required')">Number of Staff is required.</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('wholeNumber')">Please enter a whole number (no decimals).</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('min')">Number of Staff cannot be negative.</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfEmployees')?.hasError('max')">Number of Staff cannot exceed {{ accountLimits.numberOfEmployees.max | number }}.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Phone
                        </label>
                        <div class="col-md-9">
                          <input type="tel" class="form-control"
                                 [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.phone')?.invalid
                               && organizationForm.get('organizeInfo.phone')?.touched }"
                                 id="phoneInput" formControlName="phone"
                                 [maxlength]="accountTextLimits.phone">
                          <div  class="invalid-feedback" >
                            <div *ngIf="organizationForm.get('organizeInfo.phone')?.hasError('required')">
                              Phone is required.
                            </div>
                            <div *ngIf="organizationForm.get('organizeInfo.phone')?.hasError('maxlength')">
                              Phone cannot exceed {{ accountTextLimits.phone }} characters.
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <div class="row">
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Number of Volunteers
                        </label>
                        <div class="col-md-9">
                          <input type="number" step="1" class="form-control"
                                [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.numberOfVoulenteers')?.invalid
                              && organizationForm.get('organizeInfo.numberOfVoulenteers')?.touched }"
                                id="dd" formControlName="numberOfVoulenteers"
                                 [min]="accountLimits.numberOfVoulenteers.min" [max]="accountLimits.numberOfVoulenteers.max">
                          <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.invalid && organizationForm.get('organizeInfo.numberOfVoulenteers')?.touched" class="invalid-feedback">
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('required')">Number of Volunteers is required.</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('wholeNumber')">Please enter a whole number (no decimals).</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('min')">Number of Volunteers cannot be negative.</div>
                            <div *ngIf="organizationForm.get('organizeInfo.numberOfVoulenteers')?.hasError('max')">Number of Volunteers cannot exceed {{ accountLimits.numberOfVoulenteers.max | number }}.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-lg-6 col-sm-12">
                      <div class="form-group row">
                        <label class="col-md-3 col-form-label form-control-label">
                          Industry
                        </label>
                        <div class="col-md-9">
                          <select class="form-control"
                                  [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.industry')?.invalid
                               && organizationForm.get('organizeInfo.industry')?.touched }"
                                  name="industry" id="industry" formControlName="industry">
                            <option *ngFor="let value of industries" [value]="value.id">{{value.name}}</option>

                          </select>
                          <div  class="invalid-feedback" >
                            Industry is required.
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div>
                    <label class="form-control-label">Main Aims</label>
                    <textarea class="form-control"
                              [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.description')?.invalid
                               && organizationForm.get('organizeInfo.description')?.touched }"
                              rows="7" id="mainAimsInput" formControlName="description"
                                 [maxlength]="accountTextLimits.description">
                  </textarea>
                    <app-char-counter [control]="organizationForm.get('organizeInfo.description')"
                                      [max]="accountTextLimits.description"
                                      [lineBreakCost]="1"></app-char-counter>
                    <div  class="invalid-feedback" >
                      <div *ngIf="organizationForm.get('organizeInfo.description')?.hasError('required')">
                        Main Aims is required.
                      </div>
                      <div *ngIf="organizationForm.get('organizeInfo.description')?.hasError('maxlength')">
                        Main Aims cannot exceed {{ accountTextLimits.description }} characters.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card" >
              <div class="card-body">
                <div class="p-2 mb-2">
                  <div>
                    <label class="form-control-label">References</label>
                    <textarea class="form-control"
                              [ngClass]="{ 'is-invalid': organizationForm.get('organizeInfo.references')?.invalid
                               && organizationForm.get('organizeInfo.references')?.touched }"
                              rows="7" formControlName="references"
                                 [maxlength]="accountTextLimits.references">
                  </textarea>
                    <app-char-counter [control]="organizationForm.get('organizeInfo.references')"
                                      [max]="accountTextLimits.references"
                                      [lineBreakCost]="1"></app-char-counter>
                    <div  class="invalid-feedback" >
                      <div *ngIf="organizationForm.get('organizeInfo.references')?.hasError('required')">
                        References is required.
                      </div>
                      <div *ngIf="organizationForm.get('organizeInfo.references')?.hasError('maxlength')">
                        References cannot exceed {{ accountTextLimits.references }} characters.
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="card"          >
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  Payment Account
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row" >
                <div class="col-12">
                  <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                    <tr>
                      <th>Account Holder</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let payment of organization?.paymentInfo" >
                      <td [attr.data-id]="payment.id">{{ payment.accountHolderName}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-sm mt-3" (click)="addPaymentInfo()">Add Payment Account</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  Contact
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row" >
                <div class="col-12">
                  <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                    <tr>
                      <th>Name</th>
                      <th class="text-center">Position</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let contact of organization?.contactInfo" >
                      <td [attr.data-id]="contact.id">{{ contact.firstName + ' ' + contact.lastName }}</td>
                      <td class="text-center">{{ contact.position}}</td>

                    </tr>
                    </tbody>
                  </table>
                  <div class="d-flex justify-content-end">
                    <button type="button" class="btn btn-primary btn-sm mt-3" (click)="onContractClick()">Add contact</button>
                  </div>
                </div>
              </div>
            </div>
          </div>





          <div class="card">
            <div class="card-body">
              <button class="btn btn-primary" type="submit">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>

</div>





